import {
  Box,
  Button,
  Divider,
  OutlinedInput,
  InputLabel,
  IconButton,
  InputAdornment,
  FormControl,
  FormHelperText,
  Grid,
  Select,
  MenuItem,
} from "@mui/material";
import { useCallback, useEffect, useState, useRef } from "react";
import { makeStyles } from "@mui/styles";
import { onlyNumber, rem } from "assets/js/common";
import axios from "axios";
import { Controller, useForm, FormProvider } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { stepAction, setUserAction } from "redux/reducers/join";
import { useHistory } from "react-router-dom";
import Email from "components/ui/join/email";
import Address from "components/ui/join/address";
import { getCryptoPwd, displayTel, displayBirth } from "assets/js/common";

const useStyles = makeStyles((theme) => ({
  step3: {
    "& .map": {
      display: "none",
      margin: "10px 0",
      position: "relative",
      width: "100%",
      height: "350px",
      scrollY: "auto",
      "& .clseBtn": {
        textAlign: "right",
        "& img": {
          cursor: "pointer",
          padding: rem(10),
        },
      },
    },
  },
}));

export default function JoinStep3(props) {
  const crypto = require("crypto");

  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.join);
  const history = useHistory();
  const [dbSubmit, setDbSubmit] = useState(false);

  const [showPwd, setShowPwd] = useState({
    pwd: false,
    pwdChk: false,
  });
  const [favStoreList, setFavStoreList] = useState([]);
  const classes = useStyles();
  // const {
  //   register,
  //   handleSubmit,
  //   watch,
  //   form.control,
  //   setError,
  //   clearErrors,
  //   form.setValue,
  //   getValues,
  //   reset,
  //   trigger,
  //   formState: { form.formState.errors, form.formState.submitCount },
  // } = useForm({
  //   defaultValues: {
  //     pwd: "", // 간편비밀번호
  //     pwdChk: "",
  //     // nm: "이름", // 이름
  //     // birth: "20000101", // 생년월일
  //     // cph: "01012341234", // 연락처
  //     // gender: "1", // 성별(1: 남, 2: 여)
  //     email: "", // 이메일
  //     emailAddr: "naver",
  //     zip: "", // 우편번호
  //     addr: "", // 주소
  //     addrDtl: "", // 상세주소
  //     favMt: "", // 단골매장코드
  //   },
  // });

  const form = useForm({
    mode: "onChange",
    defaultValues: {
      pwd: "", // 간편비밀번호
      pwdChk: "",
      // nm: "이름", // 이름
      // birth: "20000101", // 생년월일
      // cph: "01012341234", // 연락처
      // gender: "1", // 성별(1: 남, 2: 여)
      email: "", // 이메일
      emailAddr: "",
      zip: "", // 우편번호
      addr: "", // 주소
      addrDtl: "", // 상세주소
      favTp: "",
      favMt: "", // 단골매장코드
      favMk: "",
    },
  });

  form.watch("pwd", false);
  form.watch("pwdChk", false);
  form.watch("favTp", false);

  const onSubmit = (data) => {
    const hashedPw = getCryptoPwd(data.pwd);

    let form = {
      ...user,
      ...data,
      pwd: hashedPw,
      email: data.email
        ? `${data.email}@${data.emailStr ? data.emailStr : data.emailAddr}`
        : "",
    };

    if (data.favTp) {
      const fav = data.favTp.split(".");
      const tp = fav[0];
      const cd = fav[1];

      if (tp == "1") {
        form.favMt = cd;
      } else {
        form.favMk = cd;
      }
    }
    delete form.pwdChk;
    delete form.favTp;

    console.log("form", form);
    setDbSubmit(true);
    axios.post("/api/mb/member/regist", form).then((res) => {
      if (res.data.data) {
        history.push("/join/complete");
      }
    });
  };

  const onReset = () => {
    form.reset({
      pwd: "", // 간편비밀번호
      pwdChk: "",
      nm: user.name, // 이름
      birth: user.birth, // 생년월일
      cph: user.cph, // 연락처
      gender: user.gender, // 성별(1: 남, 2: 여)
      email: "", // 이메일
      emailAddr: "",
      emailStr: "",
      zip: "", // 우편번호
      addr: "", // 주소
      addrDtl: "", // 상세주소
      favMt: "", // 단골매장코드
      no: user.no,
    });
  };

  const loadFavStore = () => {
    axios
      .get(`/api/st/store-code`, {
        params: {
          tp: "",
          useYn: "Y",
        },
      })
      .then((res) => {
        setFavStoreList(res.data.data);
      });
  };
  useEffect(() => {
    form.setValue("pwd", onlyNumber(form.getValues("pwd")));
  }, [form.getValues("pwd")]);

  useEffect(() => {
    form.setValue("pwdChk", onlyNumber(form.getValues("pwdChk")));
  }, [form.getValues("pwdChk")]);

  useEffect(() => {
    onReset();
    loadFavStore();
  }, []);

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className={classes.step3}>
        <Box className="box-type-6">
          <h3 className="h3">
            회원님의 추가 정보를
            <br />
            입력해주세요
          </h3>
        </Box>
        <Box className="box-type-5" mt={1}>
          <Grid container spacing={1} className="form-group-wrap" mt={9}>
            <Grid item xs={12} md={6}>
              <FormControl variant="outlined">
                <InputLabel shrink>간편 비밀번호</InputLabel>
                <OutlinedInput
                  id="pwd"
                  inputProps={{
                    maxLength: 6,
                  }}
                  type={showPwd.pwd ? "tel" : "password"}
                  placeholder="간편 비밀번호 6자리 입력"
                  aria-describedby="error-pw"
                  {...form.register("pwd", {
                    minLength: 6,
                    maxLength: 6,
                  })}
                  endAdornment={
                    <InputAdornment position="end">
                      {form.getValues("pwd") && (
                        <IconButton
                          aria-label="view"
                          type="button"
                          className={showPwd.pwd ? "btn-view-off" : "btn-view"}
                          onClick={() => {
                            setShowPwd({
                              ...showPwd,
                              pwd: !showPwd.pwd,
                            });
                          }}
                          edge="end"
                        />
                      )}
                    </InputAdornment>
                  }
                />
                {(form.formState.errors.pwd?.type === "minLength" ||
                  form.formState.errors.pwd?.type === "maxLength") && (
                  <FormHelperText id="error-pw" className="error">
                    숫자 6자리를 입력해주세요.
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl variant="outlined">
                <InputLabel shrink>간편 비밀번호 재입력</InputLabel>
                <OutlinedInput
                  id="pwdChk"
                  inputProps={{
                    maxLength: 6,
                  }}
                  type={showPwd.pwdChk ? "tel" : "password"}
                  placeholder="간편 비밀번호 재입력"
                  aria-describedby="error-pw"
                  {...form.register("pwdChk", {
                    validate: (val) => {
                      if (!val || form.getValues("pwd") == val) return true;
                      else return false;
                    },
                  })}
                  endAdornment={
                    <InputAdornment position="end">
                      {form.getValues("pwdChk") && (
                        <IconButton
                          aria-label="view"
                          type="button"
                          className={
                            showPwd.pwdChk ? "btn-view-off" : "btn-view"
                          }
                          onClick={() => {
                            setShowPwd({
                              ...showPwd,
                              pwdChk: !showPwd.pwdChk,
                            });
                          }}
                          edge="end"
                        />
                      )}
                    </InputAdornment>
                  }
                />
                {form.formState.errors.pwdChk?.type === "validate" && (
                  <FormHelperText id="error-pw" className="error">
                    비밀번호가 일치하지 않습니다.
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl>
                <InputLabel shrink>단골매장 선택</InputLabel>
                <Select
                  displayEmpty
                  {...form.register("favTp")}
                  defaultValue=""
                >
                  <MenuItem style={{ display: "none" }} value="">
                    <em className="placeholder">단골매장을 선택해주세요.</em>
                  </MenuItem>
                  {favStoreList.map((store, i) => (
                    <MenuItem key={store.cd} value={`${store.tp}.${store.cd}`}>
                      <em className="placeholder">{store.nm}</em>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Box>

        <Divider className="divider-type-2" />
        <Box className="box-type-5">
          <Grid container spacing={1} className="form-group-wrap">
            <Grid item xs={12} md={6}>
              <FormControl>
                <InputLabel>회원번호</InputLabel>
                <OutlinedInput disabled value={user.no} />
                {user.isOrgUser && (
                  <FormHelperText id="error-email" className="error">
                    회원님은 이미 메가훼밀리카드 회원으로 가입되어 있습니다.
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl>
                <InputLabel>이름</InputLabel>
                <OutlinedInput disabled value={user.name} />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl>
                <InputLabel>휴대폰 번호</InputLabel>
                <OutlinedInput disabled value={displayTel(user.cph)} />
              </FormControl>
            </Grid>

            <Grid item xs={8} md={6}>
              <FormControl>
                <InputLabel>생년월일</InputLabel>
                <OutlinedInput
                  type="tel"
                  value={displayBirth(user.birth)}
                  disabled
                />
              </FormControl>
            </Grid>
            <Grid item xs={4} md={6}>
              <FormControl>
                <InputLabel>성별</InputLabel>
                <OutlinedInput
                  type="text"
                  value={user.gender == 1 ? "남자" : "여자"}
                  disabled
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <Email />
            </Grid>
            <Grid item xs={12} md={6}>
              <Address />
            </Grid>
          </Grid>
        </Box>
        <Box mb={10} className="box-type-6">
          <Button
            variant="contained"
            color="primary"
            type="submit"
            fullWidth
            disabled={dbSubmit}
          >
            회원가입
          </Button>
        </Box>
      </form>
    </FormProvider>
  );
}
